import { render } from "./QrCodeModal.vue?vue&type=template&id=156b1ee4"
import script from "./QrCodeModal.vue?vue&type=script&lang=js"
export * from "./QrCodeModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__